import EN from './files/en'

export default {
  en: EN
}
